import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description: {
      hosted:
        'The document must be in your **host’s name** and must be **less than 3 months old**.',
      selfHosted:
        'The document must be in **your name** and must be **less than 3 months old**.',
    },
    list: {
      ELECTRICITY: {
        subtitle:
          'Bill or certificate of water, electricity or gas contract or rent receipt',
        title: 'Utilities bill',
      },
      INCOME_TAX_NOTICE: {
        subtitle:
          '{lastYear} tax assessment and {lastYear} residence tax notice',
        title: 'Tax assessment',
      },
      INCOME_TAX_NOTICE_AFTER_SEPTEMBER: {
        subtitle: 'Document from {lastYear}',
        title: 'Residence tax notice',
      },
      INTERNET: {
        subtitle: 'ADSL or fibre-optic internet subscription only',
        title: 'Internet bill',
      },
      LANDLINE: {
        subtitle: 'Phone numbers starting with 01, 02, 03, 04, 05 or 09',
        title: 'Landline bill',
      },
    },
    seeRefusedDocuments: 'List of unsupported documents',
    title: 'Proof of address',
  },
  fr: {
    description: {
      hosted:
        'Le document doit être au **nom de votre hébergeur** et dater de **moins de 3 mois**.',
      selfHosted:
        'Le document doit être à **votre nom** et dater de **moins de 3 mois**.',
    },
    list: {
      ELECTRICITY: {
        subtitle:
          'Facture ou attestation de contrat d’eau, d’éléctricité ou gaz ou quittance de loyer',
        title: 'Facture de charges',
      },
      INCOME_TAX_NOTICE: {
        subtitle:
          'Taxe d’habitation {lastYear} ou avis sur le revenu {lastYear}',
        title: 'Avis d’imposition',
      },
      INCOME_TAX_NOTICE_AFTER_SEPTEMBER: {
        subtitle: 'Document de l’année {lastYear}',
        title: 'Taxe d’habitation',
      },
      INTERNET: {
        subtitle: 'Abonnement ADSL ou Fibre uniquement',
        title: 'Facture d’internet',
      },
      LANDLINE: {
        subtitle:
          'Numéros de téléphone commençant par 01, 02, 03, 04, 05 ou 09',
        title: 'Facture de téléphone fixe',
      },
    },
    seeRefusedDocuments: 'Voir les documents non pris en charge',
    title: 'Justificatif de domicile',
  },
});

export default locales;
